import { CkEditorCustom } from './CkEditorCustom';

export default CkEditorCustom;
